module.exports = __webpack_public_path__ + "img/alert.4591c150.svg";